import React, { createContext, useState, useContext, useEffect } from 'react';
import { DEMO_USER } from '../demo/mockData';

const AuthContext = createContext(null);

/**
 * Demo Auth Provider - Always in demo mode
 * This is a standalone demo version that never makes API calls
 */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(DEMO_USER);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Always use demo user
    setUser(DEMO_USER);
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    console.log('[DEMO] Mock login called with:', email);
    return { success: true };
  };

  const register = async (userData) => {
    console.log('[DEMO] Mock register called with:', userData);
    return { success: true };
  };

  const logout = () => {
    console.log('[DEMO] Mock logout called - ignored in demo mode');
    // In demo mode, we don't actually log out
  };

  const updateUser = (updatedData) => {
    console.log('[DEMO] Mock updateUser called with:', updatedData);
    // In demo mode, we don't actually update
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      error,
      login,
      register,
      logout,
      updateUser,
      isAuthenticated: true, // Always authenticated in demo
      isDemoMode: true
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth må brukes innenfor AuthProvider');
  }
  return context;
};

export default AuthContext;
